


/*
    let remainingTime = 10 * 60;
    
    const timerElement = document.getElementById('timer');
    const cartTimerEl = document.querySelector('.cart-timer');
    
    function formatTime(num) {
      return num < 10 ? '0' + num : num;
    }

    function updateTimer() {
      const minutes = Math.floor(remainingTime / 60);
      const seconds = remainingTime % 60;
      
      timerElement.textContent = formatTime(minutes) + ':' + formatTime(seconds);

      remainingTime--;

      if (remainingTime < 0) {
        clearInterval(timerInterval);
        cartTimerEl.style.display = 'none';
      }
    }

    updateTimer();
    const timerInterval = setInterval(updateTimer, 1000);

*/

let timerInterval = null, endTime = null;

// Format function
function fmt(num){
  return num < 10 ? '0' + num : String(num);
}

function updateTimer() {
  const tEl = document.getElementById('timer');
  const cEl = document.querySelector('.cart-timer');
  if(!tEl || !cEl || !endTime) return;

  const diff = endTime - Date.now();
  if(diff <= 0) {
    console.log('[Timer] Time is up, resetting timer');
    resetTimer();
    return;
  }

  cEl.style.display = 'inline-flex';  // ensure visible
  const minutes = Math.floor(diff / 60000),
        seconds = Math.floor((diff % 60000) / 1000);

  tEl.textContent = fmt(minutes) + ':' + fmt(seconds);
}

function startTimer() {
  console.log('[Timer] Starting timer...');
  const now = Date.now();
  const savedEnd = localStorage.getItem('cartTimerEndTime');

  if(savedEnd && +savedEnd > now) {
    endTime = +savedEnd;
    console.log('[Timer] Continuing existing countdown. End:', new Date(+savedEnd).toLocaleTimeString());
  } else {
    endTime = now + 13 * 60 * 1000;
    console.log('[Timer] New 10-min countdown. End:', new Date(endTime).toLocaleTimeString());
    localStorage.setItem('cartTimerEndTime', endTime);
  }

  if(!timerInterval) {
    timerInterval = setInterval(updateTimer, 1000);
  }
  updateTimer();
}

function stopTimer() {
  console.log('[Timer] Stopping timer...');
  if(timerInterval) {
    clearInterval(timerInterval);
    timerInterval = null;
  }
  const cEl = document.querySelector('.cart-timer');
  if(cEl) cEl.style.display = 'none';
}

function resetTimer() {
  console.log('[Timer] Resetting timer...');
  localStorage.removeItem('cartTimerEndTime');
  endTime = null;
  stopTimer();
}

// Track last known state so we only run logic on actual changes
let lastState = null;

function checkCartTimerConditions(){
  const hasShoes = !!document.querySelector('input[name="has_shoes"][value="yes"]');
  const bodyTest = document.body.getAttribute('data-timer-test') === 'true';

  // Debug log
  console.log('[Observer] hasShoes:', hasShoes, 'bodyTest:', bodyTest);

  // Build new state
  const newState = { hasShoes, bodyTest };

  // If no change from last time, skip
  if (lastState
      && lastState.hasShoes === newState.hasShoes
      && lastState.bodyTest === newState.bodyTest) {
    return;
  }
  lastState = newState;

  if(hasShoes && bodyTest){
    startTimer();
  } else {
    resetTimer();
  }
}

const initCartTimerObserver=()=>{


// 2) Set up MutationObserver to watch for relevant changes
const observerTimer = new MutationObserver(() => {
  checkCartTimerConditions();
});

// Observe entire body for child changes (so we detect added/removed input)
// and attribute changes for data-timer-test
observerTimer.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['data-timer-test']
});
}

